import { render, staticRenderFns } from "./EmailTemplateAdd.vue?vue&type=template&id=7ed87090&scoped=true&"
import script from "./EmailTemplateAdd.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed87090",
  null
  
)

export default component.exports